import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import { IOption } from '../RequestFormPersonalInfo/ControlComponents';
import classNames from 'classnames';

interface IRequestFormSelect {
    id: string;
    className?: string;
    hasErrors?: boolean;
    options?: (string | number | IOption)[];
    defaultValue?: string | number;
    onChange: (value: string | number) => void;
    icon?: ReactNode;
    showArrow?: boolean;
    children?: ReactNode;
    isAllInclusive?: boolean;
}

const SelectElementWrapper = styled.div<{ showLeftIcon: boolean }>`
    min-width: 120px;
    height: 45px;
    border: 1px solid #c3c3c3;
    border-radius: 0;
    padding: 0;
    font-size: 14px;
    cursor: pointer;
    line-height: 1.1;
    background-color: #fff;
    position: relative;

    .requestFormSelect__leftIcon {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 0;
    }

    .requestFormSelect__arrow {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        z-index: 0;
    }

    &.is-invalid {
        border-color: #ee3d58;
    }

    select {
        position: relative;
        z-index: 1;
        background-color: transparent;
        border: none;
        padding: 10px 0;
        padding-left: ${(props) => (props.showLeftIcon ? '40px' : '10px')};
        padding-right: 40px;
        margin: 0;
        width: 100%;
        height: 45px;
        font-family: inherit;
        font-size: inherit;
        cursor: inherit;
        line-height: inherit;
        outline: none;
        text-align: ${(props) => (props.showLeftIcon ? 'center' : 'left')};
        text-align-last: ${(props) => (props.showLeftIcon ? 'center' : 'left')};
        -moz-text-align-last: ${(props) => (props.showLeftIcon ? 'center' : 'left')};
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
    }

    select:focus + .focus {
        position: absolute;
        top: -1px;
        left: -1px;
        right: -1px;
        bottom: -1px;
        border: 1px solid blue;
        border-radius: inherit;
        border-color: #66afe9;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08), 0 0 8px rgba(102, 175, 233, 0.6);
    }
`;

export const RequestFormSelect = (props: IRequestFormSelect) => {
    const {
        showArrow = true,
        hasErrors = false,
        defaultValue,
        icon,
        id,
        options,
        children,
        isAllInclusive,
    } = props;
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(e.target.value);
    };

    const showLeftIcon = Boolean(props.icon);

    return (
        <SelectElementWrapper
            showLeftIcon={showLeftIcon}
            className={classNames('requestFormSelectWrapper', props.className, {
                'is-invalid': hasErrors,
            })}
        >
            {showLeftIcon && <span className="requestFormSelect__leftIcon">{icon}</span>}

            <select autoComplete="off" value={defaultValue} id={id} onChange={handleChange}>
                {options?.map((e, i) =>
                    typeof e === 'string' || typeof e === 'number' ? (
                        <option value={e} key={`${id}-${i}`}>
                            {e}
                        </option>
                    ) : (
                        <option value={e.value} key={`${id}-${i}`}>
                            {e.label}
                        </option>
                    ),
                ) || children}
            </select>
            <span className="focus"></span>
            {showArrow && (
                <ArrowDownIcon width={14} height={14} className="requestFormSelect__arrow" />
            )}
        </SelectElementWrapper>
    );
};
